import { FacturationNetStatus } from "@/Billing/Api/FacturationNet/Dto/FacturationNetStatus";
import { BillingFacturationNetResponse, FacturationNetClaimInfo } from "@/Billing/Api/FacturationNet/Dto/Responses/FacNetBillLightResponse";
import { Client } from "@/Common/Api/Client";
import { ErrorMessage } from "@/Common/Api/Dto/ErrorMessage";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { Encounter } from "@/Patient/Models/MedicalSummary/Encounter";

class FacturationNetManager {
    public static createBill(
        encounter: Encounter,
        patientContactId: string,
        callback: () => void = null
    ): void {
        const siteName = cacheStore.GetSiteById(encounter.SiteId).Model.ClinicalName;

        Client.Postv2(
            ServerOperations.Server.FacturationNetClient_CreateClaimWebUI,
            {
                EncounterId: encounter.Id,
                IsSRV: sessionStore.isScheduledVisitChecked != null ? !sessionStore.isScheduledVisitChecked : null
            },
            response => {
                let bill = new BillingFacturationNetResponse();
                bill.CreatedByEmployeeId = sessionStore.getCurrentEmployee().ContactFacetId;
                bill.ClaimId = response.ClaimId as string;
                bill.BillDate = encounter.ConsultationDate;
                bill.Status = FacturationNetStatus.NoStatus;
                bill.Codes = "";
                bill.PreAmount = "";
                bill.Amount = "";
                if (patientStore.PatientMedicalNoteModels[patientContactId]) {
                    let noteModel = patientStore.PatientMedicalNoteModels[patientContactId];
                    noteModel = noteModel.set("FacturationNetBills", noteModel.get("FacturationNetBills").push(bill));

                    patientStore.PatientMedicalNoteModels[patientContactId] = noteModel;
                    patientStore.EmitChangeToListeners();
                }
                FacturationNetManager.reloadClaimsOnWindowClose(
                    response.ClaimUrl,
                    `FacNet_${bill.ClaimId}`,
                    callback
                );
            },
            error => sessionStore.showPopup({
                title: cacheStore.GetString("WarningLabel"),
                content: IsNullOrWhiteSpace(error[0].Code) ? error[0].Message : cacheStore.GetString(error[0].Code).replaceAll("{Site Name}", siteName),
                showCancel: true
            })
        );
    }

    public static openBill(claimId: string, callback: () => void = null): void {
        Client.Postv2(
            ServerOperations.Server.FacturationNetClient_OpenClaimWebUI,
            { ClaimId: claimId },
            response => FacturationNetManager.reloadClaimsOnWindowClose(
                response.ClaimUrl,
                `FacNet_${claimId}`,
                callback
            ),
            error => sessionStore.showPopup(error)
        );
    }

    public static deleteBill(claimId: string, responseHandlingFunction: () => void): void {
        Client.Postv2(
            ServerOperations.Server.FacturationNetClient_CancelClaim,
            {
                ClaimId: claimId
            },
            response => {
                if (response.IsSuccess == true)
                    responseHandlingFunction();
            }
        );
    }

    public static getUpdatedClaimStatuses(claimIds: number[], responseHandlingFunction: (claimInfos: FacturationNetClaimInfo[], deletedIds: number[], errors: ErrorMessage[]) => void): void {
        Client.Postv2(
            ServerOperations.Server.FacturationNetClient_GetClaimInfo,
            { ClaimIds: claimIds },
            response => responseHandlingFunction(response.ClaimInfos, response.DeletedClaimIds, null),
            err => responseHandlingFunction(null, null, err)
        );
    }

    public static isInvoiceStatusClosed(): boolean {
        return false;
    }

    private static reloadClaimsOnWindowClose(
        claimUri: string,
        windowId: string,
        callback: () => void = null
    ): void {
        const claimWindow = MyleHelper.OpenNewWindow(
            claimUri,
            windowId,
            window.innerWidth - 100
        );

        // reload claims when the claim window closes
        // use an interval since onClose will not be called for cross-site windows
        const claimWindowCheckInterval = window.setInterval(
            () => {
                if (!claimWindow || claimWindow.closed) {
                    if (callback) {
                        callback();
                    }
                    clearInterval(claimWindowCheckInterval);
                }
            },
            1000
        );
    }
}

export { FacturationNetManager };
